// "Added by Harsh · 12 Oct, 10:30 · Edited by Riya · 13 Oct, 09:15" — the
// small who-did-it line in a record's detail popup. Names are saved on the
// record (createdByName / updatedByName, utils/activity.ts). An older
// record only has the creator's id: it shows a name when that's you.

import { useAuth } from '../context/AuthContext';

type Authored = {
  createdBy?: string; createdByName?: string; createdAt?: unknown;
  updatedBy?: string; updatedByName?: string; updatedAt?: unknown;
};

function toDate(v: unknown): Date | null {
  if (!v) return null;
  if (typeof v === 'string') { const d = new Date(v); return isNaN(+d) ? null : d; }
  if (typeof v === 'object' && v && 'toDate' in v && typeof (v as { toDate: unknown }).toDate === 'function') {
    return (v as { toDate: () => Date }).toDate();
  }
  return null;
}
const fmt = (d: Date | null) => d
  ? `${d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}, ${d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}`
  : '';

export default function AuthorLine({ record }: { record: Authored }) {
  const { user } = useAuth();
  const nameFor = (id?: string, saved?: string) => saved || (id && user && id === user.id ? user.name : '');
  const added  = nameFor(record.createdBy, record.createdByName);
  const edited = record.updatedByName ? nameFor(record.updatedBy, record.updatedByName) : '';
  if (!added && !edited) return null;
  const part = (label: string, name: string, when: unknown) => (
    <span>
      {label} <strong style={{ color: 'var(--text-2)', fontWeight: 600 }}>{name}</strong>
      {fmt(toDate(when)) && <span style={{ fontFamily: 'var(--font-num)' }}> · {fmt(toDate(when))}</span>}
    </span>
  );
  return (
    <div style={{ fontSize: 11.5, color: 'var(--text-3)', display: 'flex', flexWrap: 'wrap', gap: '2px 12px' }}>
      {added && part('Added by', added, record.createdAt)}
      {edited && part('Edited by', edited, record.updatedAt)}
    </div>
  );
}

